// extracted by mini-css-extract-plugin
module.exports = {"primary700":"#383a70"};